<template>
  <HgLink
    tag="button"
    type="button"
    icon="Print"
    :class="$style.printButton"
    @click="printListing"
    >{{ t('print') }}</HgLink
  >
</template>

<script lang="ts" setup>
import { HgLink } from '@smg-real-estate/domus';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

defineOptions({
  name: 'PrintButton',
});

const emit = defineEmits<{
  printButtonClick: [];
}>();

const printListing = () => {
  emit('printButtonClick');
  globalThis.print();
};
</script>

<style lang="scss" module>
@import '@/assets/variables';

@media (max-width: $viewport-md-min) {
  button.printButton {
    display: none;
  }
}
</style>
